export default __webpack_public_path__ + "static/media/mongo.0368dd10.svg";